import type { ApiResponse } from '@evimo/client/runtime';
import type { z } from 'zod';

/**
 * Parse an OpenAPI client Raw response as wire JSON for Zod validation.
 *
 * Typed `*.value()` applies FromJSON transformers that:
 * - turn OpenAPI optional-nullable `null` into `undefined`
 * - coerce `date-time` strings into `Date`
 *
 * Web Zod schemas validate the HTTP JSON contract (nulls + ISO strings), so
 * callers that still Zod-parse must read `raw.json()` instead of `value()`.
 */
export async function parseClientJsonResponse<T>(
  apiResponse: ApiResponse<unknown>,
  schema: z.ZodType<T>,
): Promise<T> {
  return schema.parse(await apiResponse.raw.json());
}
